module.exports = {"meta":{"description":"Yoop is a new way to attend events","keywords":"music, sports, ticket, event, show, concert, creators, fans, artist, athletes, teams, tickets, ticketing, seat, seats, festival, bands, game, live, app"}}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src891534606/src/modules/web/src/js/i18n/english/meta.en.i18n.json
// module id = 1209
// module chunks = 0